import styles from './about.module.scss';
import { useAppStore } from '../../app.context';
import { observer } from 'mobx-react';
import Data from '../../data.json';
import { Images } from '../../components/images';
import classNames from 'classnames';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const About = observer(() => {
  const location = useLocation();

  const device: 'prime' | 'mid' | 'one' = location.pathname.split('/')[2] as
    | 'prime'
    | 'mid'
    | 'one';

  const [colorHex, setColorHex] = useState(Data[device].about.colors[0].color);

  const deviceColors = Data[device].about;

  const deviceInfo = Data[device].info;
  const deviceFunctions = Data[device].functions;

  const images = deviceColors.colors.filter(
    color => colorHex === color.color
  )[0].images;

  const colorName = deviceColors.colors.filter(
    color => colorHex === color.color
  )[0].name;

  return (
    <>
      <div className={styles.imgSlider}>
        <Images
          images={images}
          className={styles.carousel}
          classNameSlider={styles.slider}
          isShowButtonFullScreen={false}
          isShowArrows
        />

        <div className={styles.colors}>
          {deviceColors.colors.map((color, index) => (
            <div
              key={index}
              className={classNames(styles.noActive, {
                [styles.isActive]: colorHex === color.color
              })}
              onClick={() => setColorHex(color.color)}
            >
              <div
                className={styles.color}
                style={{ backgroundColor: color.color }}
              ></div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.container}>
        <h2 className={styles.name}>
          {deviceColors.title},
          <br />
          {colorName}
        </h2>
        <p className={styles.price}>{deviceColors.price}</p>
        <div className={styles.description}>
          <p dangerouslySetInnerHTML={{ __html: deviceInfo }} />
          {deviceFunctions.map(el => (
            <div className={styles.properties}>
              <div className={styles.propertiesImage}>
                <img src={`/img/${el.img}`} alt='mg' />
              </div>
              <p dangerouslySetInnerHTML={{ __html: el.text }} />
            </div>
          ))}
        </div>
        <div className={styles.warranty}>
          <div>
            <div className={styles.propertiesImage}>
              <img src='/img/warranty.svg' alt='' />
            </div>
            <p>
              Міжнародна гарантія — <b>12 місяців.</b>
            </p>
          </div>
        </div>
        <div className={styles.sets}>
          <p>
            <b>До набору входять:</b>
          </p>
          <div className={styles.set}>
            <div className={styles.setImages}>
              <img src='/img/check.svg' alt='' />
            </div>
            <p>
              {device === 'prime'
                ? 'девайс IQOS ILUMA i PRIME (тримач і зарядний пристрій)'
                : device === 'one'
                ? 'девайс IQOS ILUMA i ONE'
                : 'девайс IQOS ILUMA i (тримач і зарядний пристрій)'}
            </p>
          </div>
          <div className={styles.set}>
            <div className={styles.setImages}>
              <img src='/img/check.svg' alt='' />
            </div>
            <p>USB-кабель (Type-C)</p>
          </div>
          <div className={styles.set}>
            <div className={styles.setImages}>
              <img src='/img/noCheck.svg' alt='' />
            </div>
            <p>
              адаптер для зарядки <b>не входить</b> до набору
            </p>
          </div>
        </div>
      </div>
    </>
  );
});

export { About };
